// extracted by mini-css-extract-plugin
export var cartIcon = "_mj-0";
export var cartIconContainer = "_mj-1";